import { GetPipelineStageProjectResponse } from '@/api/queries/pipelines/pipelineStageProjects';
import { isDraggableProjectCardData } from '@/ui/pages/pipelinePage/components/PipelineStageWithMemory';
import { ProjectCardWithData } from '@/ui/pages/pipelinePage/components/ProjectCardWithData';
import { useDndContext } from '@dnd-kit/core';
import React, { ComponentPropsWithRef, FC } from 'react';

const ProjectCardOverlayDndContextWrapper: FC<ComponentPropsWithRef<'div'>> = (
  props
) => {
  const dndContext = useDndContext();
  const activeData = dndContext.active?.data.current;

  if (!isDraggableProjectCardData(activeData)) {
    console.warn(
      'ProjectCardOverlayDndContextWrapper: Not dragging a project card'
    );
    return null;
  }

  return <ProjectCardOverlay project={activeData.project} {...props} />;
};

const ProjectCardOverlay: FC<
  {
    project: GetPipelineStageProjectResponse;
  } & ComponentPropsWithRef<'div'>
> = (props) => {
  const { ref, project, ...rest } = props;

  return (
    <ProjectCardWithData
      className="rotate-3 opacity-60 cursor-grabbing"
      ref={ref}
      project={project}
      {...rest}
    />
  );
};

export default ProjectCardOverlayDndContextWrapper;
